export default function App() {
  return (
    <div className="container">
      <h1 className="title">Ведуться технічні роботи</h1>
      <p className="subtitle">
        Наш сайт тимчасово недоступний.<br />
        Будь ласка, завітайте пізніше.
      </p>
      <div className="status">[ SYSTEM MAINTENANCE MODE ]</div>
    </div>
  );
}
